// Builds the cart's selectedProduct from a pack product. Shared by the product
// picker and the picker-less preselection, so both send the same order shape.
export const buildSelectedProduct = (
  product,
  { isSubscribe = false, subscriptionProducts, shouldUseBundleTitle = false, thankYouPageProductName } = {}
) => {
  const subscriptionMatch =
    isSubscribe && Array.isArray(subscriptionProducts)
      ? subscriptionProducts.find((p) => p.amount === product.amount)
      : null;

  return {
    sku: product.sku?.trim(),
    amount: product.amount,
    billed_amount: product.billed_amount,
    konnektive_id: product.konnektive_id?.trim(),
    bundle_products: product.bundle_products,
    warranty_price: product.warranty_price,
    warranty_product_id: subscriptionMatch?.warranty_product_id ?? product.warranty_product_id ?? null,
    display_name: product.display_name,
    generic_name: product.generic_name,
    bundle_title: shouldUseBundleTitle ? product.bundle_title : null,
    price: product.price,
    old_price: product.old_price,
    shipping_price: product.shipping_price,
    promo_discounted_price: product.promo_discounted_price,
    promo_shipping_price: product.promo_shipping_price,
    fake_products: product.fake_products,
    enable_fake_products: product.enable_fake_products,
    shipping_konnektive_id: subscriptionMatch?.shipping_konnektive_id ?? product.shipping_konnektive_id ?? null,
    thankYouPageProductName,
    isSubscribe,
  };
};
